import 'src/material/global/vendor/datatables/jquery.dataTables';
import 'src/material/global/vendor/datatables/datatables.css';

import Vue from 'vue';
import moment from 'moment'
import vSelect from 'vue-select';
import mixin from '../../../mixins/mixin';
import stripeAccountsService from '../../../services/stripe_accounts';
import paymentService from '../../../services/payment';
import defaultTemplateService from '../../../services/default-template';
import bookingService from '../../../services/booking';
import automationService from '../../../services/automation';

var clipboard = '';

export default {
  data() {
    return {
      filterByName: [],
      filterByStatus: 2,
      payments: {},
      paymentsPageCount: 0,
      paymentsCurrentPage: 1,
      searchText: '',
      payment: {
        rental_id: null,
        booking_id: null,
      },
      selectedPayment: {
        "histories": []
      },
      permalinkUrl: '',
      error: null,
      success: false,
      loading: false,
      mode: 'grid',
      captured: true,
      paymentDetails: false,
      statusOptions: {'0': this.$t("payments.index.payment_status.pending"), '1':this.$t("payments.index.payment_status.paid"), "2":this.$t("payments.index.payment_status.all_payments")},
      noLocalPayments: true,
      stripe_accounts: [],
      stripe_account_id: null,
      sendPayment: {
        type: 'mail',
        language: 'fr'
      },
      cancelPaymentId: null,
      smallLoading: false,
      rentals: [],
      templates: [],
      paymentId: null,
      activeTab: 'payments',
      totalPageCountsArr: [],
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    vSelect,
    VLoading : require('components/loading/loading.vue'),
    VStripeConnect : require('components/stripe-connect/connect.vue'),
    VScheduledPaymentsTab: require('../ScheduledPaymentsTab.vue')
  },
  mixins:[mixin],
  async mounted() {
    let vm = this;
    vm.loading = true;
    await this.changeTab();
    await vm.get_payments();
    vm.getStripeAccounts();
    automationService.getCustomShortCodes(this);
    $(".panel-overlay" ).click(function() {
      vm.closePaymentDetail();
    });

    if (clipboard) {
      clipboard.destroy();
    }
    clipboard = new Clipboard('.btn8');
    clipboard.on('success', function(e) {
      toastr.success(vm.$t('payments.detail.permalink_copied'));
      e.clearSelection();
    });
    clipboard.on('error', function(e) {
      toastr.error(vm.$t('something_went_wrong'));
    });

    await defaultTemplateService.get(vm);
    vm.loading = false;
  },
  watch: {
    payments: {
      handler: function (val, oldVal) {
        if(this.payments.length > 0) {
          for(var i=0; i<this.payments.length; i++){
            if (this.payments[i].imported == 0) {
              this.noLocalPayments = false;
              break;
            }
          }
        }
      },
      deep: true
    },
    'stripe_account_id': function (newVal, oldVal){
      this.payment.stripe_account_id = this.stripe_account_id;
    },
    'payment.booking_id': function (newVal, oldVal){
      if(newVal) {
        stripeAccountsService.getBookingById(newVal , this);
      }
    },
    searchText() {
      this.smallLoading = true;
      this.paymentsCurrentPage = 1;
      this.get_payments(this);
    },
    filterByStatus() {
      this.smallLoading = true;
      this.paymentsCurrentPage = 1;
      this.get_payments(this);
    },
  },
  methods: {
    paymentHistoryFilter(date){
      if (!date) {
        return 'N/A'
      }
      moment.locale('fr', {
        months : this.$t('months'),
        weekdaysShort : this.$t('medWeekDays'),
        monthsShort : this.$t('shortMonths'),
      });
      return moment(date, 'YYYY-MM-DD hh:mm:ss').format("DD MMMM YYYY hh:mm:ss");
    },
    new_payment(payment_type) {
      let vm = this;
      // if payment_type is 1 it is payment, if 0 it is deposit
      vm.captured = payment_type;
      paymentService.checkUsersPaymentAccess(vm);
    },
    addPaymentOrDeposit(type) {
      let vm = this;
      vm.closeModal("#payment-or-deposit");
      vm.new_payment(type);
    },
    async save_payment(payment) {
      let vm = this;
      vm.smallLoading = true;
      if(!payment.booking_id) {
        payment.booking_id = null;
      }
      if(vm.captured) {
        payment.captured = 1;
        mixpanel.track("web.payments.create");
      } else {
        payment.captured = 0;
        mixpanel.track("web.payments.create.caution");
      }
      await paymentService.save(vm, payment);
      if (vm.payment &&  vm.payment.id) {
        this.get_payments();
      }
      
      vm.closeModal('#payment-modal');
      
    },
    get_payments_by_page(page = 1) {
      if (!(this.paymentsCurrentPage === page || page > this.paymentsPageCount || page < 1)) {
        this.smallLoading = true;
        this.paymentsCurrentPage = page;
        this.get_payments();
      }
    },
    async get_payments() {
      await paymentService.get(this);
      this.smallLoading = false;
    },
    getStripeAccounts(){
      stripeAccountsService.get(this);
    },
    openPaymentDetail(payment) {
      if (payment.stripe_account_id) {
        let vm = this;
        vm.paymentDetails = true;
        vm.selectedPayment = payment;
        vm.permalinkUrl = window.location.protocol + "//" + window.location.host + "/#/p/"+ payment.permalink;
        $(".panel-overlay").fadeIn();
        $(".payment-right-menu .panel").addClass("active");
        $(".payment-right-menu .panel").css({"right": "0"});
        $(".pannel_sec_second").css({ "right": "-350px" });
      }
      return false;
    },
    closePaymentDetail() {
      let vm = this;
      $(".payment-right-menu .panel").removeClass("active");
      $(".panel-overlay").fadeOut();
      $(".pannel_sec_second").css({ "right": "-350px"});
      vm.paymentDetails = false;
    },
    openSendPaymentModal (payment) {
        let vm = this;
        let sendMessage = !payment.captured ? 'Send deposit' : 'Send payment';
        vm.closePaymentDetail();
        if (payment.booking && payment.booking.guest) {
          let guestCountry = null;
          if (payment.booking.guest.country) {
            guestCountry = (payment.booking.guest.country).toLowerCase();
          }

          if (guestCountry && (guestCountry === 'fr' || guestCountry === 'en' || guestCountry === 'es' || guestCountry === 'pt')) {
            vm.sendPayment.language = guestCountry
          }
        }
      var template = vm.templates.filter(function (t) {
          if (vm.sendPayment.language) {
            return t.name === sendMessage && t.lang === vm.sendPayment.language;
          }
        })[0];
      let link = window.location.protocol + "//" + window.location.host + "/#/p/"+ payment.permalink;

        vm.sendPayment.email = payment.customer_email;

        vm.sendPayment.message = template.context.replace(/\[PAYMENT:TITLE]+/g, payment.title)
            .replace(/\[PAYMENT:DESCRIPTION]+/g, payment.description)
            .replace(/\[DEPOSIT:TITLE]+/g, payment.title)
            .replace(/\[DEPOSIT:DESCRIPTION]+/g, payment.description)
            .replace(/\[DEPOSIT:LINK]+/g, link)
            .replace(/\[PAYMENT:LINK]+/g, link);
        vm.sendPayment.message = vm.generateMessageContent(vm.sendPayment.message, payment);
        vm.sendPayment.subject = `${payment.title} - ${payment.description}`;
        vm.sendPayment.rental_id = payment.rental_id;
        vm.sendPayment.id = payment.id;
        vm.paymentId = payment.id;
      vm.$forceUpdate();
      vm.openModal('#send-payment-modal');
    },
    openCancelPaymentModal (paymentId) {
      let vm = this;
      vm.closePaymentDetail();
      vm.cancelPaymentId = paymentId;
      vm.openModal('#cancel-payment-modal');
    },
    redirectToPaymentDetails(id) {
      let vm = this;
      vm.closePaymentDetail();
      Vue.router.push({
        name: 'payments.detail',
        params: { id: id }
      });
    },
    cancelPayment(paymentId) {
        let vm = this;
        vm.smallLoading = true;
        paymentService.cancelPayment(this, paymentId);
    },
    sendPaymentEmailOrSms (sendPayment) {
      let vm = this;
      vm.smallLoading = true;
      if(vm.sendPayment.type == 'mail') {
        paymentService.sendPayment(sendPayment, this);
      } else {
        paymentService.sendPaymentBySms(sendPayment, this);
      }
    },
    getPaymentHistoryActionName(actionName) {
      let name;
      if(localStorage.getItem('lang') == 'fr') {
        switch (actionName) {
          case 'created':
            name = 'CRÊÊ';
            break;
          case 'view':
            name = 'VU';
            break;
          case 'success':
            name = 'SUCCÊS';
            break;
        }
      } else {
        name = actionName.toUpperCase();
      }
      return name;
    },
    getTemplateByLang(lang) {
      let vm = this;

      let payment = vm.payments.find(function (payment) {
        return payment.id === vm.paymentId;
      });

      let sendMessage = !payment.captured ? 'Send deposit' : 'Send payment';

      let template = vm.templates.find(function (template) {
        return template.name === sendMessage && template.lang === lang;
      });

      let link = window.location.protocol + "//" + window.location.host + "/#/p/"+ payment.permalink;

      vm.sendPayment.subject = template.subject;

      vm.sendPayment.message = template.context.replace(/\[PAYMENT:TITLE]+/g, payment.title)
        .replace(/\[PAYMENT:DESCRIPTION]+/g, payment.description)
        .replace(/\[PAYMENT:LINK]+/g, link);
      vm.sendPayment.message = vm.generateMessageContent(vm.sendPayment.message, payment);
      vm.sendPayment.subject = vm.generateMessageContent(vm.sendPayment.subject, payment);
    },
    generateMessageContent(message, payment) {
      let price = null;
      let checking = null;
      let checkout = null;

      if (payment.booking) {
        price = this.getPriceAmount(payment.booking);
        checking = payment.booking.checking;
        checkout = payment.booking.checkout;
      }
      let content = message.replace(/\[WELCOME_FORM_URL]+/g, payment.booking ? window.location.protocol  + "//" + window.location.host + '/#/booking/' + payment.booking.permalink + '/welcome': '')
                    .replace(/\[CHECKIN_FORM_URL]+/g, payment.booking ? window.location.protocol  + "//" + window.location.host + '/#/booking/' + payment.booking.permalink + '/checkin': '')
                    .replace(/\[RENTAL:NAME]+/g, payment.booking && payment.booking.rental && payment.booking.rental.name ? payment.booking.rental.name : '-')
                    .replace(/\[RENTAL:HOSTFIRSTNAME]+/g, payment.booking && payment.booking.rental && payment.booking && payment.booking.rental.owner_first_name ? payment.booking.rental.owner_first_name : '-')
                    .replace(/\[RENTAL:HOSTLASTNAME]+/g, payment.booking && payment.booking.rental && payment.booking && payment.booking.rental.owner_last_name ? payment.booking.rental.owner_last_name : '-')
                    .replace(/\[RENTAL:EMAIL]+/g, payment.booking && payment.booking.rental && payment.booking.rental && payment.booking.rental.email ? payment.booking.rental.email : '-')
                    .replace(/\[RENTAL:PHONE]+/g, payment.booking && payment.booking.rental && payment.booking.rental.user && payment.booking.rental.user.phone ? payment.booking.rental.user.phone : '-')
                    .replace(/\[RENTAL:ADDRESS]+/g, payment.booking && payment.booking.rental && payment.booking.rental.address ? payment.booking.rental.address : '-')
                    .replace(/\[RENTAL:CITY]+/g, payment.booking && payment.booking.rental && payment.booking.rental.city ? payment.booking.rental.city : '-')
                    .replace(/\[RENTAL:COUNTRY]+/g, payment.booking && payment.booking.rental && payment.booking.rental.country ? payment.booking.rental.country.name : '-')
                    .replace(/\[RENTAL:ARRIVAL_TIME]+/g, payment.booking && payment.booking.rental && payment.booking.rental.arrival_time ? payment.booking.rental.arrival_time : '-')
                    .replace(/\[RENTAL:DEPARTURE_TIME]+/g, payment.booking && payment.booking.rental && payment.booking.rental.departure_time ? payment.booking.rental.departure_time : '-')
                    .replace(/\[GUEST:FIRST_NAME]+/g, payment.booking && payment.booking.guest && payment.booking.guest.first_name ? payment.booking.guest.first_name : '-')
                    .replace(/\[GUEST:LAST_NAME]+/g, payment.booking && payment.booking.guest && payment.booking.guest.last_name ? payment.booking.guest.last_name : '-')
                    .replace(/\[GUEST:NAME]+/g, payment.booking && payment.booking.guest && payment.booking.guest.first_name && payment.booking.guest.last_name ? payment.booking.guest.first_name + " " + payment.booking.guest.last_name : '-')
                    .replace(/\[GUEST:EMAIL]+/g, payment.booking && payment.booking.guest && payment.booking.guest.email ? payment.booking.guest.email : '-')
                    .replace(/\[GUEST:PHONE]+/g, payment.booking && payment.booking.guest && payment.booking.guest.phone ? payment.booking.guest.phone : '-')
                    .replace(/\[GUEST:CITY]+/g, payment.booking && payment.booking.guest && payment.booking.guest.city ? payment.booking.guest.city : '-')
                    .replace(/\[GUEST:COUNTRY]+/g, payment.booking && payment.booking.guest && payment.booking.guest.country ? payment.booking.guest.country : '-')
                    .replace(/\[GUEST:ADDRESS]+/g, payment.booking && payment.booking.guest && payment.booking.guest.address ? payment.booking.guest.address : '-')
                    .replace(/\[INQUIRY:ARRIVE]+/g, payment.booking && payment.booking.time_in ? payment.booking.time_in : '-')
                    .replace(/\[INQUIRY:DEPART]+/g, payment.booking && payment.booking.time_out ? payment.booking.time_out : '-')
                    .replace(/\[INQUIRY:COST]+/g, price ? price : '-')
                    .replace(/\[INQUIRY:PRICE]+/g, payment.booking && payment.booking.price ? payment.booking.price : '-')
                    .replace(/\[INQUIRY:NIGHTS]+/g, checking && checkout ? checkout - checking : '-')
                    .replace(/\[INQUIRY:ADULTS]+/g, payment.booking && payment.booking.nbr_adults ? payment.booking.nbr_adults : '-')
                    .replace(/\[INQUIRY:CHILDREN]+/g, payment.booking && payment.booking.nbr_children ? payment.booking.nbr_children : '-')
                    .replace(/\[INQUIRY:BOOK_DATE]+/g, payment.booking && payment.booking.created_at ? payment.booking.created_at : '-')
                    .replace(/\[BOOKING:ID]+/g, payment.booking ? payment.booking.id : '-')
                    .replace(/\[BOOKING:RES-ID]+/g, payment.booking && payment.booking.booking_com_res_id ? payment.booking.booking_com_res_id : '-')
                    .replace(/\[BOOKING:CONFIRMATION-CODE]+/g, payment.booking && payment.booking.confirmation_code ? payment.booking.confirmation_code : '-')
                    .replace(/\[BOOKING:CHECKING]+/g, payment.booking ? moment(payment.booking.checking, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-')
                    .replace(/\[BOOKING:CHECKOUT]+/g, payment.booking ? moment(payment.booking.checkout, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-')
                    .replace(/\[BOOKING:PLATFORM]+/g, payment.booking && payment.booking.channel && payment.booking.channel.name ? payment.booking.channel.name : 'Direct')
                    .replace(/\[CHECKING:DD-MM-YYYY]+/g, payment.booking ?  moment(payment.booking.checking, 'YYYY-MM-DD').format('DD-MM-YYYY') : '-')
                    .replace(/\[CHECKOUT:DD-MM-YYYY]+/g, payment.booking ? moment(payment.booking.checkout, 'YYYY-MM-DD').format('DD-MM-YYYY') : '-')
                    .replace(/\[BOOKING:ADULTS]+/g, payment.booking ? payment.booking.nbr_adults : '-')
                    .replace(/\[BOOKING:PRICE]+/g, price ? price : '-')
                    .replace(/\[INVOICE:LINK]+/g, payment.booking ? window.location.protocol + "//" + window.location.host + '/#/invoice/' + payment.booking.id : '-')
                    .replace(/\[CONTRACT:LINK]+/g, payment.booking ? window.location.protocol + "//" + window.location.host + '/#/booking/' + payment.booking.permalink + '/contract' : '-')
                    .replace(/\[AUTOPAYMENT:AMOUNT]+/g, price ? price : '-');
      return this.replaceCustomShortCodes(content, payment.booking && payment.booking.rental_id ? payment.booking.rental_id : null)
    },
    async createAndSend(payment) {
      await this.save_payment(payment);
      vm.closeModal('#payment-modal');
      if (this.payment && this.payment.id) {
        this.openSendPaymentModal(this.payment);
      }
    },
    changePaymentStatus(payment) {
      payment.paymentStatus = payment.status;
      bookingService.changePaymentStatus(this, payment);
    },
    changeTab (tab = null) {
      if (tab) {
        this.activeTab = tab;
        switch (tab) {
          case 'payments':
            Vue.router.push({
              name: 'payments.index',
            });
            break;
          case 'schedulePayment':
            Vue.router.push({
              name: 'payments.schedule-payment'
            });
            break;
        }
      } else if (this.$route.path === '/payments/schedule-payment') {
        this.activeTab = 'schedulePayment';
        Vue.router.push({
          name: 'payments.schedule-payment'
        });
      }
    },
    getCurrency (payment) {
      return payment.booking && payment.booking.rental && payment.booking.rental.currency ? payment.booking.rental.currency.symbol : (payment.user ? payment.user.currency.symbol : '&#x20AC;')
    }
  },
  computed: {
    listView() {
      return this.payments;
    },
    account() {
      return this.$store.state.account;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/payments/index/index.js